module.exports = __webpack_public_path__ + "img/talk-sport-2.a9acc07b.png";